import { alpha } from '@mui/material';
import type { Theme } from '@mui/material';

/**
 * Oranzovy podklad hasice, ktery nestihne limit vyjezdu (HO-162). Pruhlednost ve svetlem
 * rezimu predava volajici, aby odpovidala zelenemu podkladu JEDU v teze komponente.
 */
export const tintNestiha = (theme: Theme, svetlaPruhlednost: number) =>
    alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.22 : svetlaPruhlednost);
